import React from 'react';
import './SmartClosetPage.css';

const SmartClosetPage = () => {

  return (
    <div className="smartcloset-page">
      <div className="container">
        
        {/* Hero Section with Fashion Theme */}
        <div className="smartcloset-hero">
            <h1>SmartCloset</h1>
          <div className="hero-visual">
            <div className="closet-preview">
              <div className="closet-rack">
                <div className="clothing-item shirt">🧥</div>
                <div className="clothing-item pants">👖</div>
                <div className="clothing-item dress">👗</div>
                <div className="clothing-item jacket">👖</div>
              </div>
              <div className="ai-suggestion">
                <div className="suggestion-bubble">
                  <span>Perfect for today's weather!</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Project Overview */}
        <div className="project-section">
          <h2>About SmartCloset</h2>
          <p>
            SmartCloset is an intelligent wardrobe management system that helps users organize their clothing 
            and create outfits without opening the closet. The app integrates the Mask R-CNN Model to cutout clothing items from images
            and weather conditions to suggest perfect outfit combinations.
          </p>
          <p>
            Using computer vision(Mask R-CNN Model), the app automatically categorizes clothing items
             and provides weather-appropriate with weather API to make suggestions for any occasion.
          </p>
        </div>

        {/* Technology Stack */}
        <div className="tech-section">
          <h2>Technologies Used</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <div className="tech-icon">Python</div>
            </div>
            <div className="tech-item">
              <div className="tech-icon">FastAPI</div>
            </div>
            <div className="tech-item">
              <div className="tech-icon">React</div>
            </div>
            <div className="tech-item">
              <div className="tech-icon">Mask R-CNN</div>
            </div>
            <div className="tech-item">
              <div className="tech-icon">JavaScript</div>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="features-section">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">AI Clothing Recognition</div>
              <p>Automatically categorize and tag clothing items using computer vision</p>
              <div className="feature-demo">
                <img src="/projects/smartcloset/Clothing Detection Screen.PNG" alt="Clothing Detection Interface" />
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">Weather Integration</div>
              <p>Get outfit suggestions based on real-time weather conditions</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">Virtual Outfit Creation</div>
              <p>Mix and match items to create perfect outfits virtually</p>
              <div className="feature-demo">
                <img src="/projects/smartcloset/ClosetScreen.PNG" alt="Closet Screen Interface" />
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">Style Analytics</div>
              <p>Track your style preferences and get help from AI to improve your wardrobe</p>
              <div className="feature-demo">
                <img src="/projects/smartcloset/AI Chat.PNG" alt="AI Chat Interface" />
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">Social Features</div>
              <p>Share outfits and get feedback from friends and the community</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">Mobile Optimized</div>
              <p>Seamless experience across apple and android with responsive design</p>
            </div>
          </div>
        </div>

        {/* Technical Challenges */}
        <div className="challenges-section">
          <h2>Technical Challenges</h2>
          <div className="challenge-list">
            <div className="challenge-item">
              <div className="challenge-number">01</div>
              <div className="challenge-content">
                <h3>AI Model Training</h3>
                <p>Training accurate clothing recognition models with limited dataset and diverse clothing styles</p>
                <div className="challenge-demo">
                  <img src="/projects/smartcloset/MaskRCNNIMG.jpg" alt="MaskRCNN Model Architecture" />
                </div>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">02</div>
              <div className="challenge-content">
                <h3>Real-time Weather Integration</h3>
                <p>Implementing seamless weather API integration for instant outfit recommendations</p>
              </div>
            </div>
          
            <div className="challenge-item">
              <div className="challenge-number">03</div>
              <div className="challenge-content">
                <h3>Intuitive UI Design</h3>
                <p>Creating an easy-to-use interface for complex outfit creation and management features</p>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default SmartClosetPage;
